import styled from 'styled-components';

export const StyledCallPatient = styled.div`
  margin-left: 16px;
  padding-left: 12px;
  border-left: 1px solid #dbdde2;
`;
